export default "__VITE_ASSET__6cFcxy5t__"